var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { CellLabel } from '../elements/cell-label';
import { pick } from 'lodash';
var cls = classNames('slice-main-section-layout');
export var SliceMainSectionLayoutDefaultProps = {
  colors: {
    text: 'mid'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    padding-bottom: ", ";\n  "], ["\n    ", ";\n    padding-bottom: ", ";\n  "])), theme.APPLY_COLORS, theme.UNIT(4))
});
// -------- Components -------->
var My = {
  NAME: 'SliceMainSectionLayout',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(CellLabel)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
export var SliceMainSectionLayout = function (props) {
  var componentProps = useComponentProps(My.NAME, props, SliceMainSectionLayoutDefaultProps);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity,
    colors = componentProps.colors;
  var labelColors = pick(colors, 'text');
  var label = entity === null || entity === void 0 ? void 0 : entity.label;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, label && React.createElement(My.Label, {
    colors: labelColors
  }, label), children);
};
SliceMainSectionLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;